import { type UniversalCategory } from '@/features/shop/services/UniversalCategories/types'
import { findCategoryById } from '@/features/shop/services/UniversalCategories/utils'

export const getProductHierarchicalCategories = (
  universalCategories: UniversalCategory[],
  product: { hierarchical_categories?: Record<string, string[]> },
) => {
  const { hierarchical_categories = {} } = product
  const sortedKeys = Object.keys(hierarchical_categories).sort()
  const lastKey = sortedKeys.at(-1) || ''
  const categoryList = hierarchical_categories[lastKey]?.[0]?.split('>').slice(0, 3) ?? []

  const matchedCategories: UniversalCategory[] = []
  categoryList.every((category) => {
    const splitCategory = category.trim().split('_')
    const universalCategory = findCategoryById(universalCategories, Number(splitCategory[0]))
    if (universalCategory) {
      matchedCategories.push(universalCategory)
      return true
    } else {
      return false
    }
  })

  return matchedCategories
}
